import axios from "axios";
import Lockr from "lockr";
import store from "@/store";
import cache from '@/utils/cache'
import {GetCurrentUserInfoApi} from '@/api/user'
import requrls from '@/api/url'

//注入授权信息
export function addAuth(token,sessionId){
    return new Promise((resolve,reject)=>{
        axios.defaults.headers['authKey']=token
        axios.defaults.headers['sessionId']=sessionId
        resolve(true)
    })
}

//清空登录信息
export function removeAuth(){
    return new Promise((resolve,reject)=>{
        // store.commit('SET_LANG',null)
        store.commit('SET_UserToken',null)
        store.commit('SET_UserId',null)
        store.commit('SET_UserAppCss',null)
        store.commit('SET_UserData',null)
        resolve(true)
    })
}

//判断是否登录
export function checkAuth(){
    let userData=store.state.app.UserData
    let UserToken=store.state.app.UserToken
    let UserId=store.state.app.UserId
    if(UserId && UserToken && userData){
        return userData
    }else{
        //判断缓存
        let Lockr_UserToken=Lockr.get('mtrshops_UserToken')
        let Lockr_UserId=Lockr.get('mtrshops_UserId')
        let Lockr_UserData=Lockr.get('mtrshops_UserData')
        if(Lockr_UserToken && Lockr_UserId && Lockr_UserData){
            store.commit('SET_UserId',cache.getCacheTemp(Lockr_UserId))
            store.commit('SET_UserToken',cache.getCacheTemp(Lockr_UserToken))
            store.commit('SET_UserData',Lockr_UserData)

            return Lockr_UserData;
        }else{
            //清空登录
            removeAuth()
            return false;
        }
    }
}

//更新用户信息
export function updateUserData(){
    let UserToken=store.state.app.UserToken
    let UserId=store.state.app.UserId
    let alluserData=checkAuth()
    return new Promise((resolve,reject)=>{
        if(alluserData){
            //拼接参数
            if(alluserData.hasOwnProperty('type') && alluserData.type==2){
                resolve()
            }else{
                GetCurrentUserInfoApi({
                    reqUrl:requrls.GetCurrentUserInfo,
                }).then((res)=>{
					console.log('GetCurrentUserInfoApi', res)
                    let findata1=res.ResultData
                    //登录成功
                    if(findata1.UserId && findata1.UserToken){
                        store.commit('SET_UserId', findata1.UserId)
                        store.commit('SET_UserToken', findata1.UserToken)
                        store.commit('SET_UserData', findata1)
                    }
                    // console.log('更新用户信息',res)
                    resolve()
                })
            }
        }else{
            reject()
        }
    })
}

//获取用户信息
export function getUserData(){
    let userData=store.state.app.UserData
    return userData?userData:null;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js